import React from 'react';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts';

const formatNumber = (v) => new Intl.NumberFormat('pt-BR').format(v || 0);

const CORES = {
  dentro: '#2e7d32',
  fora: '#c62828'
};

export default function SlaSolicitacoesChart({ dados, loading }) {
  if (loading) {
    return (
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid rgba(46,125,50,0.2)', minHeight: 320, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={32} />
      </Paper>
    );
  }

  const dentro = dados?.dentroPrazo ?? 0;
  const fora = dados?.foraPrazo ?? 0;
  const chartData = [
    { name: 'SLA', dentroPrazo: dentro, foraPrazo: fora }
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        height: '100%',
        border: '1px solid rgba(46,125,50,0.2)',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(232,245,233,0.35) 100%)',
        boxShadow: '0 4px 24px rgba(46,125,50,0.08)'
      }}
    >
      <Typography variant="h6" fontWeight={700} sx={{ color: '#2e7d32' }}>
        SLA de Solicitações
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Realizadas dentro ou fora do prazo ({formatNumber(dados?.total || dentro + fora)} no total).
      </Typography>
      {dentro + fora === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 6 }}>
          Sem solicitações para calcular SLA no período.
        </Typography>
      ) : (
        <Box sx={{ width: '100%', height: 280 }}>
          <ResponsiveContainer>
            <BarChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tickFormatter={formatNumber} tick={{ fontSize: 12 }} />
              <Tooltip formatter={(value, name) => [formatNumber(value), name === 'dentroPrazo' ? 'Dentro do prazo' : 'Fora do prazo']} />
              <Legend formatter={(v) => (v === 'dentroPrazo' ? 'Dentro do prazo' : 'Fora do prazo')} />
              <Bar dataKey="dentroPrazo" stackId="sla" fill={CORES.dentro} radius={[4, 4, 0, 0]} maxBarSize={80}>
                <Cell fill={CORES.dentro} />
              </Bar>
              <Bar dataKey="foraPrazo" stackId="sla" fill={CORES.fora} radius={[0, 0, 4, 4]} maxBarSize={80}>
                <Cell fill={CORES.fora} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>
      )}
    </Paper>
  );
}
